<script>
  import Plotly from 'plotly.js-gl2d-dist' 
  //import 'plotly.js-gl2d-dist/lib/locales/ru'
  var moment = require('moment-timezone');
  // Импорт функции для парсинга IPC-буфера
  import { tableFromIPC } from 'apache-arrow';


  export default {





		props: {
		city: String,
		pdk: Object, 
		nodehost: String,
		appdate: String,
		apphour: Number,
		variable: String,
		varspace: String,
		background_stations: Object,
		default_background_stations: Object,
		standardize: Boolean,
		min_date: String,
		max_date: String,
		varnames: Object,
		selected: Number,
		aggrunit_ext: String,
		confidence: Number
	},
	data: () => ({
		show: false,
		panel: [0],
		menu2: false,
		fetching: true,
		stat_done: true,
		back_done: true,
		justify: 'center',
		locale: 'ru-RU',
		date: null,
		opacity: 0.2,
		prefetch: 0,
		datebind: ['Yes'],
		aggrbind: ['Yes'],
		freescale: 'Yes',
		aggrunit: 'hour',
		aggrunits: [
			{ text: 'Исходные данные (3 ч.)', value : 'hour' },
			{ text: 'Сутки', value : 'day' },
			{ text: 'Неделя', value : 'week' },
			{ text: 'Месяц', value : 'month' },
			{ text: 'Год', value : 'year' }
		],
		vars: {
			meteo: {
				temperature: 'temp',
				humidity: 'humirel',
				pressure: 'pressea',
				cloud: 'cloudtot',
				wind: 'windspd',
				prec: 'prec03',
				pet: 'pet_clodyn_light',
				mrt: 'mrt',
				utci: 'utci'
			},
			air: {
				nh3: 'nh3',
				susp_sol: 'susp_sol',
				pm10: 'pm10',
				pm25: 'pm25',
				no2: 'no2',
				so2: 'so2',
				o3: 'o3',
				co: 'co',
				ch4: 'ch4',
				h2s: 'h2s',
				no: 'no',
				c6h6: 'c6h6',
				c10h8: 'c10h8',
				c8h8: 'c8h8',
				c7h8: 'c7h8',
				c6h5oh: 'c6h5oh',
				ch2o: 'ch2o',
			}
		},
		duration: 168,
		durations: {
			hour: 168,
			day: 60,
			week: 52,
			month: 24,
			year: 10
		},
		cache: {
			meteo: {
				moscow: {},
				spb: {}
			},
			air: {
				moscow: {},
				spb: {}
			}
		},
		uuid: "001",
		plotindex: 0,
		data: [{
			x: [],
			y: [],
			type:"scattergl"
		}],
		options: {
			scrollZoom: true
		},
		allstations: {
			meteo: {
				moscow: [],
				spb: []
			},
			air: {
				moscow: [],
				spb: []
			} 
		},
		allcolors: ["#0000FFFF", "#FF0000FF", "#00FF00FF", "#000033FF", "#FF00B6FF", "#005300FF", "#FFD300FF", "#009FFFFF", 
					"#9A4D42FF", "#00FFBEFF", "#783FC1FF", "#1F9698FF", "#FFACFDFF", "#B1CC71FF", "#F1085CFF", "#FE8F42FF", 
					"#DD00FFFF", "#201A01FF", "#720055FF", "#766C95FF", "#02AD24FF", "#C8FF00FF", "#886C00FF", "#FFB79FFF", 
					"#858567FF", "#A10300FF", "#14F9FFFF", "#00479EFF", "#DC5E93FF", "#93D4FFFF", "#004CFFFF", "#004250FF", 
					"#39A76AFF", "#EE70FEFF", "#000064FF", "#ABF5CCFF", "#A192FFFF", "#A4FF73FF", "#FFCE71FF", "#470015FF", 
					"#D4ADC5FF", "#FB766FFF", "#ABBC00FF", "#7500D7FF", "#A6009AFF", "#0073FEFF", "#A55DAEFF", "#628402FF", 
					"#0079A8FF", "#00FF83FF", "#563500FF", "#9F003FFF", "#422D42FF", "#FFF2BBFF", "#005D43FF", "#FCFF7CFF", 
					"#9FBFBAFF", "#A75413FF", "#4A276CFF", "#0010A6FF", "#914E6DFF", "#CF9500FF", "#C3BBFFFF", "#FD4440FF", 
					"#424E20FF", "#6A0100FF", "#B58354FF", "#84E993FF", "#60D900FF", "#FF6FD3FF", "#664B3FFF", "#FE6400FF", 
					"#E4037FFF", "#11C7AEFF", "#D2818BFF", "#5B767CFF", "#203B6AFF", "#B454FFFF", "#E208D2FF", "#000114FF", 
					"#5D8444FF", "#A6FAFFFF", "#617BC9FF", "#62007AFF", "#7EBE3AFF", "#003CB7FF", "#FFFD00FF", "#07C5E2FF", 
					"#B4A739FF", "#94BA8AFF", "#CCBBA0FF", "#370031FF", "#002801FF", "#967A81FF", "#278826FF", "#CE82B4FF", 
					"#96A4C4FF", "#B42080FF", "#6E56B4FF", "#9300B9FF", "#C7303DFF", "#7366FFFF", "#0FBBFDFF", "#ACA464FF", 
					"#B675FAFF", "#D8DCFEFF", "#578D71FF", "#D85522FF", "#00C467FF", "#F3A569FF", "#D8FFB6FF", "#0118DBFF", 
					"#344236FF", "#FF9A00FF", "#575F01FF", "#C6F14FFF", "#FF5F85FF", "#7BACF0FF", "#786431FF", "#A285CCFF", 
					"#69FFDCFF", "#C65264FF", "#791A40FF", "#00EE46FF", "#E7CF45FF", "#D980E9FF", "#FFD3D1FF", "#D1FF8DFF", 
					"#240003FF", "#57A3C1FF", "#D3E7C9FF", "#CB6F4FFF", "#3E1800FF", "#0075DFFF", "#70B058FF", "#D11800FF", 
					"#001E6BFF", "#69C8C5FF", "#FFCBFFFF", "#E9C289FF", "#BF812EFF", "#452A91FF", "#AB4CC2FF", "#0E753DFF", 
					"#001E19FF", "#76497FFF", "#FFA9C8FF", "#5E37D9FF", "#EEE68AFF", "#9F3621FF", "#500094FF", "#BD9080FF", 
					"#006D7EFF", "#58DF60FF", "#475067FF", "#015D9FFF", "#63303CFF", "#02CE94FF", "#8B5325FF", "#AB00FFFF", 
					"#8D2A87FF", "#555394FF", "#96FF00FF", "#00987BFF", "#FF8ACBFF", "#DE45C8FF", "#6B6DE6FF", "#1E0044FF", 
					"#AD4C8AFF", "#FF86A1FF", "#00233CFF", "#8ACD00FF", "#6FCA9DFF", "#E14BFDFF", "#FFB04DFF", "#E5E839FF", 
					"#7210FFFF", "#6F5265FF", "#868930FF", "#632650FF", "#692620FF", "#C86E00FF", "#D1A4FFFF", "#C6D256FF", 
					"#4F674DFF", "#AEA5A6FF", "#AA2D65FF", "#C751AFFF", "#FF59ACFF", "#92664EFF", "#6686B8FF", "#6F98FFFF", 
					"#5CFF9FFF", "#AC89B2FF", "#D22262FF", "#C7CF93FF", "#FFB91EFF", "#FA948DFF", "#31224EFF", "#FE5161FF", 
					"#FE8D64FF", "#443617FF", "#C9A254FF", "#C7E8F0FF", "#449800FF", "#93AC3AFF", "#164B1CFF", "#085479FF", 
					"#742D00FF", "#683CFFFF", "#402926FF", "#A471D7FF", "#CF009BFF", "#760123FF", "#530058FF", "#0052E8FF", 
					"#2B5C57FF", "#A0D992FF", "#B01AE5FF", "#1D0324FF", "#7A3A9FFF", "#D6D1CFFF", "#A06469FF", "#6A9DA0FF", 
					"#99DB71FF", "#C038CFFF", "#7DFF59FF", "#950022FF", "#D5A2DFFF", "#1683CCFF", "#A6F945FF", "#6D6961FF", 
					"#56BC4EFF", "#FF6D51FF", "#FF03F8FF", "#FF0049FF", "#CA0023FF", "#436D12FF", "#EAAAADFF", "#BFA500FF", 
					"#262C33FF", "#55B902FF", "#79B69EFF", "#FEECD4FF", "#8BA559FF", "#8DFEC1FF", "#003C2BFF", "#3F1128FF", 
					"#FFDDF6FF", "#111A92FF", "#9A4254FF", "#959DEEFF", "#7E8248FF", "#3A0665FF", "#BD7565FF"],
				// Color counter starts at 1 — index 0 (#0000FF blue) is reserved for the background station (99999)
				numstations: {
					meteo: {
						moscow: 1,
						spb: 1,
					},
					air: {
						moscow: 1,
						spb: 1,
					}
				},
		colors: {
			meteo: {
				moscow: {},
				spb: {}
			},
			air: {
				moscow: {},
				spb: {}
			}
		},
		edit_mode: 'all',
		stations: {
			meteo: {
				moscow: {
					27605: 'Moscow (center, Balchug)',
					99999: 'Background mean'
				},
				spb: {
					26063: 'Saint Petersburg',
					99999: 'Background mean'
				}
			},
			air: {
				moscow: {
					53: 'Шаболовка',
					99999: 'Средний фон'
				},
				spb: {
					1: 'ул. Профессора Попова, дом 48',
					99999: 'Средний фон'
				}
			}
		},
		urban_stations: {
			meteo: {
				moscow: [27605],
				spb: [26063]
			},
			air: {
				moscow: [53],
				spb: [1]
			}
		},

		urbans_changed: false,
		background_changed: false,
		saved_background_stations: null,

		edit_stations: undefined,
		all: false,
		layout: {
			margin: {
				l: 50,
				r: 25,
				b: 30,
				t: 50
			},
			autosize: true,
			dragmode: 'pan',
			locale: 'en',
			xaxis: {
				autorange: false,
				type: "date",
				range: []
			}
		},
		resizeObserver: null,
		plotMutationObserver: null,
		plotReady: false,
		skipDateZoom: false
	}),
	
		methods: {
		togglePlot() {
				this.plotindex = this.plotindex === 0 ? null : 0;
			},

						// Heat stress grades by MV
				get_grade_categories() {
						// Возвращает массив категорий с диапазонами, подписями и цветами
						if (this.variable === 'pet') {
							return [
								{ y0: -100, y1: 4,    label: this.$t('grades.very_high_cold_stress'),      color: 'rgba(0, 0, 139, 0.07)' },
								{ y0: 4,    y1: 8,    label: this.$t('grades.high_cold_stress'),            color: 'rgba(65, 105, 225, 0.07)' },
								{ y0: 8,    y1: 18,   label: this.$t('grades.moderate_cold_stress'),        color: 'rgba(100, 149, 237, 0.07)' },
								{ y0: 18,   y1: 23,   label: this.$t('grades.no_thermal_stress'),           color: 'rgba(0, 255, 0, 0.07)' },
								{ y0: 23,   y1: 29,   label: this.$t('grades.moderate_heat_stress'),        color: 'rgba(255, 255, 0, 0.07)' },
								{ y0: 29,   y1: 35,   label: this.$t('grades.high_heat_stress'),            color: 'rgba(255, 165, 0, 0.07)' },
								{ y0: 35,   y1: 41,   label: this.$t('grades.very_high_heat_stress'),       color: 'rgba(255, 0, 0, 0.07)' },
								{ y0: 41,   y1: 100,  label: this.$t('grades.extreme_heat_stress'),         color: 'rgba(139, 0, 0, 0.07)' },
							];
						} else if (this.variable === 'utci') {
							return [
								{ y0: -100, y1: -40,  label: this.$t('grades.extreme_cold_stress'),          color: 'rgba(0, 0, 0, 0.07)' },
								{ y0: -40,  y1: -27,  label: this.$t('grades.very_high_cold_stress'),        color: 'rgba(0, 0, 139, 0.07)' },
								{ y0: -27,  y1: -13,  label: this.$t('grades.high_cold_stress'),             color: 'rgba(65, 105, 225, 0.07)' },
								{ y0: -13,  y1: 9,    label: this.$t('grades.moderate_cold_stress'),         color: 'rgba(100, 149, 237, 0.07)' },
								{ y0: 9,    y1: 26,   label: this.$t('grades.no_thermal_stress'),            color: 'rgba(0, 255, 0, 0.07)' },
								{ y0: 26,   y1: 32,   label: this.$t('grades.moderate_heat_stress'),         color: 'rgba(255, 255, 0, 0.07)' },
								{ y0: 32,   y1: 38,   label: this.$t('grades.high_heat_stress'),             color: 'rgba(255, 165, 0, 0.07)' },
								{ y0: 38,   y1: 46,   label: this.$t('grades.very_high_heat_stress'),        color: 'rgba(255, 0, 0, 0.07)' },
								{ y0: 46,   y1: 100,  label: this.$t('grades.extreme_heat_stress'),          color: 'rgba(139, 0, 0, 0.07)' },
							];
						}
						return [];
				},

		// Get localized title with units for the current variable
		getVarTitle() {
			let baseTitle = this.variable;
			if (this.varspace === 'air') {
				// Air quality vars have city-level keys: varnames.air[city][variable]
				if (this.varnames && this.varnames[this.varspace] && this.varnames[this.varspace][this.city]) {
					baseTitle = this.varnames[this.varspace][this.city][this.variable] || this.variable;
				}
			} else {
				// Meteo vars are flat: varnames.meteo[variable]
				if (this.varnames && this.varnames[this.varspace]) {
					baseTitle = this.varnames[this.varspace][this.variable] || this.variable;
				}
			}
		// Append unit for air quality variables
			if (this.varspace === 'air') {
				return baseTitle + ' [' + this.$t('pdk.fraction') + ']';
			}
			return baseTitle;
		},

		get_grade_shapes() {
				// Возвращает массив фигур (shapes) для Plotly — цветные полосы градаций теплового/холодового стресса + линия ПДК
				if (this.standardize) return [];
				const shapes = [];
				// PDK line for air quality variables (y=1 = normalized to daily MAC)
				if (this.varspace === 'air') {
					shapes.push({
						type: 'line',
						x0: 0,
						x1: 1,
						y0: 1,
						y1: 1,
						xref: 'paper',
						yref: 'y',
						layer: 'below',
						line: {
							color: 'rgba(0, 0, 0, 0.5)',
							width: 1,
							dash: 'dash'
						}
					});
				}
				const categories = this.get_grade_categories();
				if (categories.length === 0) return shapes;
				for (const cat of categories) {
					// Заливка области цветом
					shapes.push({
						type: 'rect',
						x0: 0,
						x1: 1,
						y0: cat.y0,
						y1: cat.y1,
						xref: 'paper',
						yref: 'y',
						fillcolor: cat.color,
						line: { width: 0 },
						layer: 'below'
					});
					// Пунктирная линия-граница на верхней границе каждой категории
					shapes.push({
						type: 'line',
						x0: 0,
						x1: 1,
						y0: cat.y1,
						y1: cat.y1,
						xref: 'paper',
						yref: 'y',
						layer: 'below',
						line: {
							color: 'rgba(0, 0, 0, 0.25)',
							width: 1,
							dash: 'dash'
						}
					});
				}
				return shapes;
		},

				get_grade_annotations() {
				// Возвращает массив аннотаций (annotations) для Plotly — текстовые подписи градаций + подпись ПДК
				if (this.standardize) return [];
				const annotations = [];
				// PDK label for air quality variables (y=1 = normalized to daily MAC)
				if (this.varspace === 'air') {
					annotations.push({
						x: 0.02,
						y: 1,
						xref: 'paper',
						yref: 'y',
						text: this.$t('pdk.label'),
						showarrow: false,
						opacity: 0.5,
						font: {
							size: 12,
							color: '#000'
						},
						xanchor: 'left',
						yanchor: 'bottom'
					});
				}
				const categories = this.get_grade_categories();
				if (categories.length === 0) return annotations;
				const labelX = 0.02; // В левой части графика

								for (const cat of categories) {
					// Определяем yanchor в зависимости от типа градации
					const isHeat = cat.label === this.$t('grades.extreme_heat_stress') ||
						cat.label === this.$t('grades.very_high_heat_stress') ||
						cat.label === this.$t('grades.high_heat_stress') ||
						cat.label === this.$t('grades.moderate_heat_stress');
					const isCold = cat.label === this.$t('grades.extreme_cold_stress') ||
						cat.label === this.$t('grades.very_high_cold_stress') ||
						cat.label === this.$t('grades.high_cold_stress') ||
						cat.label === this.$t('grades.moderate_cold_stress');

					let yanchor;
					let yPos;
					if (isCold) {
						// Холодовой стресс — под верхней границей
						yanchor = 'top';
						yPos = cat.y1;
					} else if (isHeat) {
						// Тепловой стресс — над нижней границей
						yanchor = 'bottom';
						yPos = cat.y0;
					} else {
						// Нет стресса — посередине
						yanchor = 'middle';
						yPos = (cat.y0 + cat.y1) / 2;
					}

					annotations.push({
							x: labelX,
							y: yPos,
							xref: 'paper',
							yref: 'y',
							text: cat.label,
							showarrow: false,
							opacity: 0.5,
							font: {
								size: 12,
								color: '#000'
							},
							xanchor: 'left',
							yanchor: yanchor
						});
				}
				return annotations;
		},
		// Heat stress grades by MV

		zoom_data() {
			
			var ref = this.date || this.appdate || this.max_date;
			if (!ref) return;
			
			// Интерпретируем max_date как конец дня, min_date как начало дня
			var maxMoment = moment(this.max_date).endOf('day');
			var minMoment = moment(this.min_date).startOf('day');
			
			var last = moment().tz("ETC/GMT+3");
			last.set({
				'year': ref.slice(0, 4),
				'month': ref.slice(5, 7)-1,
				'date': ref.slice(8)
			});
			
			var first = last.clone();
			
			switch (this.justify) {
				case 'right':
					first.subtract(this.duration, 'hours');
					break;
				case 'left':
					last.add(this.duration, 'hours');
					break;
		case 'center':
			first.subtract(this.duration / 2, `${this.aggrunit}s`);
			last.add(this.duration / 2, `${this.aggrunit}s`);
			// Если окно выходит за правую границу — сдвигаем всё окно влево целиком
			if (last.isAfter(maxMoment)) {
				const shift = last.diff(maxMoment);
				last.subtract(shift);
				first.subtract(shift);
			}
			// Если окно выходит за левую границу — сдвигаем всё окно вправо целиком
			if (first.isBefore(minMoment)) {
				const shift = minMoment.diff(first);
				first.add(shift);
				last.add(shift);
			}
			// Если доступный диапазон данных меньше ширины окна — показываем всё, что есть
			if (last.isAfter(maxMoment)) {
				last = maxMoment.clone();
			}
			if (first.isBefore(minMoment)) {
				first = minMoment.clone();
			}
			break;
			}
			
			// Финальная обрезка до конца дня max_date (но не дальше)
			if (last.isAfter(maxMoment)) {
				last = maxMoment.clone();
			}
			// calculate Y axis range

			let min_total = Infinity;
			let max_total = -Infinity;

			if (this.data.length > 0) {
				for (let i in this.data) {
					let seq = this.data[i].y.filter((v, j) => this.data[i].x[j] >= first && this.data[i].x[j] <= last);
					let max = Math.max.apply(null, seq);
					let min = Math.min.apply(null, seq);
					if (max > max_total) 
						max_total = max;
					if (min < min_total)
						min_total = min;
				}
			}

			// Heat stress grades by MV
			const shapes = this.get_grade_shapes();

			// Вертикальная линия выбранной даты с учетом часа
				if (this.appdate) {
					const lineDate = this.apphour != null ? this.appdate + ' ' + String(this.apphour).padStart(2, '0') + ':00:00' : this.appdate;
					shapes.push({
						type: 'line',
						x0: lineDate,
						x1: lineDate,
						y0: 0,
						y1: 1,
						xref: 'x',
						yref: 'paper',
						layer: 'above',
						line: {
							color: 'black',
							width: 1,
							dash: 'dash'
						}
				});
			}

			// Если флаг skipDateZoom установлен — не меняем range осей, только shapes/annotations/locale/title
			if (this.skipDateZoom) {
				this.layout.shapes = shapes;
				this.layout.annotations = this.get_grade_annotations();
				this.layout.locale = this.$i18n.locale;
				this.layout.title = {text: this.getVarTitle(), font: {size: 16}};
				return;
			}

			this.layout = {
				showlegend: true,
				margin: {
						l: 25,
						r: 25,
						b: 30,
						t: 50
				},
				dragmode: 'pan',
				hovermode: 'x',
				clickmode: 'event+select',
				locale: this.$i18n.locale,
				xaxis: {
						autorange: false,
						type: "date",
						range: [first.toDate(), last.toDate()],
						showspikes: true,
						spikemode: 'across',
						spikedash: 'solid',
						spikecolor: 'rgba(0,0,0,0.2)',
						spikethickness: 1
				},
				yaxis: {
						autorange: false,
						range: [min_total - 0.1 * (max_total - min_total), max_total + 0.1 * (max_total - min_total)],
						hoverformat: '.2~f'
				},
            title: {text: this.getVarTitle(), font: {size: 16}},
				shapes: shapes,
				annotations: this.get_grade_annotations()
				}
				// Heat stress grades by MV
		},

		show_cache() {
			this.data = [];

			// console.log(this.cache);

			if (this.standardize) {
				let xnum_cache = this.cache[this.varspace][this.city][this.variable][this.aggrunit][99999].x.map(Number);
				let ycache = this.cache[this.varspace][this.city][this.variable][this.aggrunit][99999].y;
				let ccache = this.cache[this.varspace][this.city][this.variable][this.aggrunit][99999].c;

				for (let s in this.stations[this.varspace][this.city]) {
					let x = this.cache[this.varspace][this.city][this.variable][this.aggrunit][s].x;
					let y = [];

					let yabs = this.cache[this.varspace][this.city][this.variable][this.aggrunit][s].y;
					let xnum = x.map(Number);

					let c = this.cache[this.varspace][this.city][this.variable][this.aggrunit][s].c;

					for (let i in xnum) {
						let j = xnum_cache.indexOf(xnum[i]);

						if (j == -1) {
							y.push(null);
						} else if (c[i] < this.confidence || c[i] == null || ccache[j] < this.confidence || ccache[j] == null) {
							y.push(null);
						} else {
							// Normalize by PDK for air (values in units of MAC fractions)
							let pdkDiv = (this.varspace == 'air' ? this.pdk[this.variable] : 1);
							y.push((yabs[i] - ycache[j]) / pdkDiv);
						}    
					} 

					this.data.push({
						id: s,
						name: this.stations[this.varspace][this.city][s],
						x: x,
						y: y,
						mode: 'lines+markers',
						type: 'scattergl',
						hoverinfo: 'y',
						line: {
							color: this.allcolors[this.colors[this.varspace][this.city][s]],
							width: 2
						},
						marker: {
							color: this.allcolors[this.colors[this.varspace][this.city][s]],
							size: 4,
							symbol: 'circle'
						}
					})
				} 
			} else {
				if (this.varspace == 'air') {
					console.log(this.pdk);
					console.log(this.variable);
				}
				for (let s in this.stations[this.varspace][this.city]) {
					let y = this.cache[this.varspace][this.city][this.variable][this.aggrunit][s].y;
					let c = this.cache[this.varspace][this.city][this.variable][this.aggrunit][s].c;
					this.data.push({
						id: s,
						name: this.stations[this.varspace][this.city][s],
						x: this.cache[this.varspace][this.city][this.variable][this.aggrunit][s].x,
						y: y.map((value, i) => { return c[i] >= this.confidence ? (this.varspace == 'air' ? value / this.pdk[this.variable] : value) : null }),
						mode: 'lines+markers',
						type: 'scattergl',
						hoverinfo: 'y',
						line: {
							color: this.allcolors[this.colors[this.varspace][this.city][s]],
							width: 2
						},
						marker: {
							color: this.allcolors[this.colors[this.varspace][this.city][s]],
							size: 4,
							symbol: 'circle'
						}
					})
				}
			}
			
						// Heat stress grades by MV
								if (this.freescale) {
					this.zoom_data();
				} else {
					const shapes = this.get_grade_shapes();
					if (this.appdate) {
						const lineDate = this.apphour != null ? this.appdate + ' ' + String(this.apphour).padStart(2, '0') + ':00:00' : this.appdate;
						shapes.push({
							type: 'line',
							x0: lineDate,
							x1: lineDate,
							y0: 0,
							y1: 1,
							xref: 'x',
							yref: 'paper',
														layer: 'above',
							line: {
								color: 'black',
								width: 1,
								dash: 'dash'
							}
						});
					}
					this.layout.shapes = shapes;
					this.layout.annotations = this.get_grade_annotations();
				}
				// Heat stress grades by MV
		},

		// async fetch_main(toload) {
		// 	var self = this;
		// 	this.stat_done = false;
		// 	this.back_done = false;

		// 	try {
		// 		// console.log(new Date().toISOString() + ' Started fetching');

		// 		const requestData = {
		// 		action: 'get',
		// 			source: self.varspace == 'meteo' ? 'rhm' : 'air',
		// 			dimension: 'temporal',
		// 			scope: 'list',
		// 			city: self.city,
		// 			stations: JSON.stringify(toload.filter(id => id != 99999)).replace('[', '(').replace(']', ')'),
		// 			variable: self.vars[self.varspace][self.variable],
		// 			aggrunit: self.aggrunit,
		// 			min_date: self.min_date,
		// 			max_date: self.max_date
		// 		};

		// 		// Выполняем запрос с await fetch
		// 		const response = await fetch(this.nodehost, {
		// 			method: 'POST',
		// 			headers: {
		// 				'Content-Type': 'application/json'
		// 			},
		// 			body: JSON.stringify(requestData)
		// 		});

		// 		if (!response.ok) {
		// 			throw new Error(`HTTP error! status: ${response.status}`);
		// 		}

		// 		const data = await response.json();
		// 		let tab = data;//JSON.parse(data);

		// 		for (let s of toload.filter(id => id != 99999)) {
		// 			self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].x = [];
		// 			self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].y = [];
		// 			self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].c = [];

		// 			let tab_station = tab.filter(row => row.fid == s);

		// 			console.log(tab_station);
					
		// 			for (const row of tab_station) {
		// 				self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].x.push(new Date(row['datetime']));
		// 				self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].y.push(row['param_avg']);
		// 				self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].c.push(Number(row['confidence']));
		// 			}
					
		// 			if (!(s in self.colors[self.varspace][self.city])) {
		// 				self.colors[self.varspace][self.city][s] = self.numstations[self.varspace][self.city];
		// 				self.numstations[self.varspace][self.city] += 1;
		// 			}

		// 			console.log(self.cache[self.varspace][self.city][self.variable][self.aggrunit][s]);
		// 		}

		// 		self.stat_done = true;
		// 		console.log('STAT DONE')
				
		// 	} catch (error) {
		// 		console.error('Error in fetch_main:', error);
		// 	}
		// },

		// async fetch_back() {
		// 	console.log(new Date().toISOString() + ' Started fetching BACK');
		// 	var self = this;
			
		// 	try {
		// 		const requestData = {
		// 			action: 'get',
		// 			source: self.varspace == 'meteo' ? 'rhm' : 'air',
		// 			dimension: 'temporal',
		// 			scope: 'all_list',
		// 			city: self.city,
		// 			stations: JSON.stringify(self.rural_stations[self.varspace][self.city]).replace('[', '(').replace(']', ')'),
		// 			variable: self.vars[self.varspace][self.variable],
		// 			aggrunit: self.aggrunit,
		// 			min_date: self.min_date,
		// 			max_date: self.max_date
		// 		};

		// 		// Выполняем запрос с await fetch
		// 		const response = await fetch(this.nodehost, {
		// 			method: 'POST',
		// 			headers: {
		// 				'Content-Type': 'application/json'
		// 			},
		// 			body: JSON.stringify(requestData)
		// 		});

		// 		if (!response.ok) {
		// 			throw new Error(`HTTP error! status: ${response.status}`);
		// 		}

		// 		const data = await response.json();
		// 		let tab = data;//JSON.parse(data);

		// 		self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999].x = [];
		// 		self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999].y = [];
		// 		self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999].c = [];
				
		// 		for (const row of tab) {
		// 			self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999].x.push(new Date(row['datetime']));
		// 			self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999].y.push(row['param_avg']);
		// 			self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999].c.push(Number(row['confidence']));
		// 		}
				
		// 		if (!(99999 in self.colors[self.varspace][self.city])) {
		// 			self.colors[self.varspace][self.city][99999] = self.numstations[self.varspace][self.city];
		// 			self.numstations[self.varspace][self.city] += 1;
		// 		}

		// 		self.back_done = true;

		// 		console.log('BACK DONE')
				
		// 		// if (self.stat_done && self.fetching) {
		// 		// 	self.fetching = false;
		// 		// 	self.show_cache();
		// 		// }
				
		// 	} catch (error) {
		// 		console.error('Error in fetch_back:', error);
		// 	}
		// },
		
		// Вспомогательная функция: читает весь ответ в Uint8Array
		async readResponseToBuffer(response) {
			const reader = response.body.getReader();
			const chunks = [];
			for (;;) {
				const { done, value } = await reader.read();
				if (done) break;
				chunks.push(value);
			}
			// Объединяем все чанки в один буфер
			const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
			const buffer = new Uint8Array(totalLength);
			let offset = 0;
			for (const chunk of chunks) {
				buffer.set(chunk, offset);
				offset += chunk.length;
			}
			return buffer;
		},

		async fetch_main(toload) {
			var self = this;
			this.stat_done = false;
			this.back_done = false;

			try {
				const requestData = {
				action: 'get',
				source: self.varspace == 'meteo' ? 'rhm' : 'air',
				dimension: 'temporal',
				scope: 'list',
				city: self.city,
				stations: JSON.stringify(toload.filter(id => id != 99999)).replace('[', '(').replace(']', ')'),
				variable: self.vars[self.varspace][self.variable],
				aggrunit: self.aggrunit,
				min_date: self.min_date,
				max_date: self.max_date
				};

				const response = await fetch(this.nodehost, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(requestData)
				});

				if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

				// Собираем весь ответ в буфер
				console.log('Fetching data...');
				const buffer = await this.readResponseToBuffer(response);
				console.log('Buffer received, size:', buffer.length);

				// Парсим буфер в таблицу (содержит все RecordBatch'и)
				const table = tableFromIPC(buffer);

				const stationsToLoad = toload.filter(id => id != 99999);
				// Инициализация кэша
				for (let s of stationsToLoad) {
				if (!self.cache[self.varspace][self.city][self.variable][self.aggrunit][s]) {
					self.cache[self.varspace][self.city][self.variable][self.aggrunit][s] = {};
				}
				self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].x = [];
				self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].y = [];
				self.cache[self.varspace][self.city][self.variable][self.aggrunit][s].c = [];
				}

				// Находим индексы колонок
				const cols = table.schema.fields.map(f => f.name.toLowerCase());
				const fidIdx = cols.indexOf('fid');
				const dtIdx = cols.indexOf('datetime');
				const paramIdx = cols.indexOf('param_avg');
				const confIdx = cols.indexOf('confidence');
				if (fidIdx === -1 || dtIdx === -1 || paramIdx === -1 || confIdx === -1) {
				throw new Error('Required columns not found in response');
				}

				const fidV = table.getChildAt(fidIdx);
				const dtV = table.getChildAt(dtIdx);
				const paramV = table.getChildAt(paramIdx);
				const confV = table.getChildAt(confIdx);

				const n = table.numRows;
				for (let i = 0; i < n; i++) {
				const fid = fidV.get(i);
				const cache = self.cache[self.varspace][self.city][self.variable][self.aggrunit][fid];
				if (cache) {
					cache.x.push(new Date(dtV.get(i)));
					cache.y.push(paramV.get(i));
					cache.c.push(Number(confV.get(i)));
				}
				}

				console.log(`[FETCH_MAIN] Всего строк: ${n}`);

								// Assign colors sequentially (starting from index 1, since index 0 is reserved for background station 99999)
				for (let s of stationsToLoad) {
				if (!(s in self.colors[self.varspace][self.city])) {
					self.colors[self.varspace][self.city][s] = self.numstations[self.varspace][self.city];
					self.numstations[self.varspace][self.city] += 1;
				}
				}

				self.stat_done = true;
				console.log('STAT DONE');
			} catch (error) {
				console.error('Error in fetch_main:', error);
			}
		},

		// ============= fetch_back =============
		async fetch_back() {
			console.log(new Date().toISOString() + ' Started fetching BACK');
			var self = this;

			try {
				const requestData = {
				action: 'get',
				source: self.varspace == 'meteo' ? 'rhm' : 'air',
				dimension: 'temporal',
				scope: 'all_list',
				city: self.city,
				stations: JSON.stringify(self.background_stations[self.varspace][self.city]).replace('[', '(').replace(']', ')'),
				variable: self.vars[self.varspace][self.variable],
				aggrunit: self.aggrunit,
				min_date: self.min_date,
				max_date: self.max_date
				};

				const response = await fetch(this.nodehost, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(requestData)
				});
				if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

				console.log('Fetching background data...');
				const buffer = await this.readResponseToBuffer(response);
				console.log('Buffer received, size:', buffer.length);

				const table = tableFromIPC(buffer);

				// Инициализация кэша для станции 99999
				if (!self.cache[self.varspace][self.city][self.variable][self.aggrunit]) {
				self.cache[self.varspace][self.city][self.variable][self.aggrunit] = {};
				}
				if (!self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999]) {
				self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999] = {};
				}
				const cache = self.cache[self.varspace][self.city][self.variable][self.aggrunit][99999];
				cache.x = [];
				cache.y = [];
				cache.c = [];

				const cols = table.schema.fields.map(f => f.name.toLowerCase());
				const dtIdx = cols.indexOf('datetime');
				const paramIdx = cols.indexOf('param_avg');
				const confIdx = cols.indexOf('confidence');
				if (dtIdx === -1 || paramIdx === -1 || confIdx === -1) {
				throw new Error('Required columns not found in background response');
				}

				const dtV = table.getChildAt(dtIdx);
				const paramV = table.getChildAt(paramIdx);
				const confV = table.getChildAt(confIdx);

				const n = table.numRows;
				for (let i = 0; i < n; i++) {
				cache.x.push(new Date(dtV.get(i)));
				cache.y.push(paramV.get(i));
				cache.c.push(Number(confV.get(i)));
				}

				console.log(`[FETCH_BACK] Всего строк: ${n}`);

								// Background station 99999 always gets blue color (index 0 in allcolors)
								if (!(99999 in self.colors[self.varspace][self.city])) {
								self.colors[self.varspace][self.city][99999] = 0;
								}

				self.back_done = true;
				console.log('BACK DONE');
			} catch (error) {
				console.error('Error in fetch_back:', error);
			}
		},

				async fetch_data() { 
					if (this.varspace === 'air' && this.city === 'spb' && this.aggrunit === 'hour') {
						return;
					}
					let toload = [];

			// console.log(this.stations[this.varspace][this.city])
			// console.log(this.cache[this.varspace])

			for (let s in this.stations[this.varspace][this.city]) 
				if (this.cache[this.varspace][this.city][this.variable][this.aggrunit][s].x == null)
				if (s != 99999) 
					toload.push(parseInt(s));

			var loadPromises = [];

			if (toload.length > 0) {
				this.fetching = true;
				loadPromises.push(this.fetch_main(toload));
			}

			const sortedArr1 = [...this.background_stations[this.varspace][this.city]].sort();
			const sortedArr2 = this.cache[this.varspace][this.city][this.variable][this.aggrunit].background_stations.sort();
			if (JSON.stringify(sortedArr1) != JSON.stringify(sortedArr2)) {
				this.cache[this.varspace][this.city][this.variable][this.aggrunit].background_stations = sortedArr1;
				this.stat_done = true;
				console.log('STAT DONE')
				if (!this.fetching) this.fetching = true;
				loadPromises.push(this.fetch_back());
			} 
			
			if (loadPromises.length == 0) {
				this.show_cache();
			} else {
				Promise.all(loadPromises).then(() => {
					this.show_cache();
					this.fetching = false;
				}).catch(error => {
					console.error('Error loading temporal data series:', error);
					this.fetching = false;
				});
			}
		},

		// Resolve 'all' sentinel to actual station IDs during initialization
		resolveBackgroundAll() {
			const updated = JSON.parse(JSON.stringify(this.background_stations));
			for (let space of ['meteo', 'air']) {
				for (let city of ['moscow', 'spb']) {
					if (updated[space][city] === 'all') {
						if (this.allstations[space] && this.allstations[space][city]) {
							updated[space][city] = this.allstations[space][city]
								.filter(item => item.ID < 99998)
								.map(item => item.ID);
						}
					}
				}
			}
			this.$emit('update:background_stations', updated);
		},

		toggleBackgroundStation(id) {
			// Deep clone the background_stations object to avoid mutating the prop directly
			const updated = JSON.parse(JSON.stringify(this.background_stations));
			const arr = updated[this.varspace][this.city];
			const idx = arr.indexOf(id);
			if (idx >= 0) {
				arr.splice(idx, 1);
			} else {
				arr.push(id);
			}
			// Emit the new object to parent via .sync
			this.$emit('update:background_stations', updated);
			this.background_changed = true;
		},

		applyBackgroundStations() {
			if (this.$refs.backgroundMenu) {
				this.$refs.backgroundMenu.isActive = false;
			}
			this.background_changed = false;
			if (this.allstations[this.varspace] && this.allstations[this.varspace][this.city]) {
				this.fetch_data();
			}
		},

		toggleAllBackgroundStations() {
			const allIds = this.allstations[this.varspace][this.city]
				.filter(item => item.ID < 99998)
				.map(item => item.ID);
			const current = this.background_stations[this.varspace][this.city];
			// If all are selected — deselect all, otherwise select all
			const allSelected = allIds.every(id => current.includes(id));
			const updated = JSON.parse(JSON.stringify(this.background_stations));
			updated[this.varspace][this.city] = allSelected ? [] : [...allIds];
			this.$emit('update:background_stations', updated);
			this.background_changed = true;
		},

		closeBackgroundMenu() {
			if (this.$refs.backgroundMenu) {
				this.$refs.backgroundMenu.isActive = false;
			}
		},

		defaultBackgroundStations() {
			// Reset to defaults from App.vue's default_background_stations prop
			const updated = JSON.parse(JSON.stringify(this.default_background_stations));
			// Resolve 'all' sentinels to actual station IDs
			for (let space of ['meteo', 'air']) {
				for (let city of ['moscow', 'spb']) {
					if (updated[space][city] === 'all') {
						if (this.allstations[space] && this.allstations[space][city]) {
							updated[space][city] = this.allstations[space][city]
								.filter(item => item.ID < 99998)
								.map(item => item.ID);
						}
					}
				}
			}
			this.$emit('update:background_stations', updated);
			this.background_changed = true;
		},

		handle_background(isActive) {
			// Save current background stations state when menu opens
			if (isActive) {
				this.saved_background_stations = JSON.parse(JSON.stringify(this.background_stations));
			}
			if (!isActive && this.background_changed) {
				this.background_changed = false;
				if (this.allstations[this.varspace] && this.allstations[this.varspace][this.city]) {
					this.fetch_data();
				}
			}
		},

		handle_urbans(isActive) {
			if (!isActive && this.urbans_changed) {
				this.urbans_changed = false;
				if (this.allstations[this.varspace] && this.allstations[this.varspace][this.city]) {
					console.log(this.urban_stations[this.varspace][this.city]);
					console.log(this.cache[this.varspace][this.city][this.variable][this.aggrunit].urban_stations)
					this.add_stations(this.urban_stations[this.varspace][this.city]);
				}
			}
		},

		remove_station(i) {
			this.stations[this.varspace][this.city] = Object.keys(this.stations[this.varspace][this.city])
				.filter(key => key !== i)
				.reduce((obj, key) => {
					return Object.assign(obj, {
						[key]: this.stations[this.varspace][this.city][key]
					});
			}, {});
			this.data.splice(this.data.findIndex(elem => elem.id == i), 1);
		},

		add_stations(ids) {
			let new_ids = ids.filter(id => id in this.stations[this.varspace][this.city]);
			if (new_ids.length > 0) {
				// only fill reload works somehow
				let temp = this.stations[this.varspace][this.city];
				for (let id of ids) {
					let i = this.allstations[this.varspace][this.city].findIndex(s => s.ID == id);
					let feature = this.allstations[this.varspace][this.city][i];
					temp[id] = feature[this.$i18n.t('fields.name')]
				}
				this.stations[this.varspace][this.city] = []; 
				this.stations[this.varspace][this.city] = temp;
			}
		},

		add_station(id) {
			if (! (id in this.stations[this.varspace][this.city]) ) {
				let i = this.allstations[this.varspace][this.city].findIndex(s => s.ID == id);
				let feature = this.allstations[this.varspace][this.city][i];

				// only fill reload works somehow
				let temp = this.stations[this.varspace][this.city];
				temp[id] = feature[this.$i18n.t('fields.name')]
				this.stations[this.varspace][this.city] = []; 
				this.stations[this.varspace][this.city] = temp;
			}
		},

		async load_allstations(city, space) {
			try {
				// Формируем данные для POST-запроса
				const requestData = {
					action: 'get',
					source: space == 'meteo' ? 'rhm' : 'air',
					dimension: 'spatial',
					mode: 'info',
					city: city
				};

				// Выполняем запрос с await fetch
				const response = await fetch(this.nodehost, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(requestData)
				});

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				const data = await response.json();

				// Инициализируем массив, если он не существует
				if (!this.allstations[space]) {
					this.allstations[space] = {};
				}
				if (!this.allstations[space][city]) {
					this.allstations[space][city] = [];
				}
				
				this.allstations[space][city] = [];
				for (let feature of data.features)
					this.allstations[space][city].push(feature.properties);
				
				// console.log(data.features);

				this.allstations[space][city].sort((a, b) => 
					a[this.$i18n.t('fields.name')] < b[this.$i18n.t('fields.name')] ? -1 : 1 
				);      
				
				this.allstations[space][city].unshift({ID: 99999, NAME: 'Фоновое среднее', NAME_EN: 'Background mean'})
				this.allstations[space][city].unshift({ID: 99998, NAME: 'Городское среднее', NAME_EN: 'Urban mean'})

				// If background stations are set to 'all', resolve to actual IDs now
				if (this.background_stations[space] && this.background_stations[space][city] === 'all') {
					// Defer resolution until after allstations is fully built
					setTimeout(() => this.resolveBackgroundAll(), 0);
				}

				this.cache[space][city] = Object.assign({}, this.vars[space]);
				for (let v in this.cache[space][city]) {
				this.cache[space][city][v] = {}
				for (let unit of this.aggrunits) {
					this.cache[space][city][v][unit.value] = {};
					for (let station of this.allstations[space][city]) {
					this.cache[space][city][v][unit.value][station.ID] = {
						x: null,
						y: null,
						c: null
					};
					this.cache[space][city][v][unit.value].background_stations = [];
					this.cache[space][city][v][unit.value].urban_stations = [];
					}
				}
				}
				
				this.prefetch += 1;
				
			} catch (error) {
				console.error('Error loading all stations for ' + city + ' ' + space + ':', error);
			}
		},

		handleResize() {
			if (this.plotReady && document.getElementById('plot')) {
				Plotly.Plots.resize('plot');
			}
		},

	handlePlotClick(data) {
			// data содержит массив points от plotly_click
			if (!data || !data.points || data.points.length === 0) return;
			const point = data.points[0];
			// x — это Date для оси типа "date"
			const clickedTime = point.x;
			if (!clickedTime) return;
			// Используем локальное время напрямую (point.x уже в локальном tz)
			const momentClicked = moment(clickedTime);
			const clickedDate = momentClicked.format('YYYY-MM-DD');
			const clickedHour = momentClicked.hours();
			// Округляем час до ближайшего кратного 3 (0, 3, 6, ...)
			const roundedHour = Math.round(clickedHour / 3) * 3;
			// Запоминаем текущий диапазон оси X
			const savedRange = this.layout.xaxis && this.layout.xaxis.range ? [...this.layout.xaxis.range] : null;
			// Флаг — не пересчитывать zoom_data при смене date/apphour
			this.skipDateZoom = true;
			// Эмитим событие для родителя (App.vue)
			this.$emit('plot_click', {
				date: clickedDate,
				hour: roundedHour
			});
			// Обновляем вертикальную линию немедленно, не полагаясь на watcher-ы.
			// Watcher appdate может не сработать, если clickedDate совпадает с текущей appdate (типично для month/year).
			// Watcher apphour может не сработать, если roundedHour совпадает с текущим apphour.
			// Обновляем здесь напрямую, чтобы линия отрисовалась в любом случае.
			const newShapes = this.get_grade_shapes();
			const lineDate = this.apphour != null ? clickedDate + ' ' + String(roundedHour).padStart(2, '0') + ':00:00' : clickedDate;
			newShapes.push({
				type: 'line',
				x0: lineDate,
				x1: lineDate,
				y0: 0,
				y1: 1,
				xref: 'x',
				yref: 'paper',
				layer: 'above',
				line: {
					color: 'black',
					width: 1,
					dash: 'dash'
				}
			});
			this.layout.shapes = newShapes;
			this.layout.annotations = this.get_grade_annotations();
			// Снимаем флаг и восстанавливаем диапазон оси X после всех watchers
			if (savedRange) {
				this.$nextTick(() => {
					this.skipDateZoom = false;
					if (this.layout.xaxis) {
						this.layout.xaxis.range = savedRange;
					}
				});
			} else {
				this.$nextTick(() => { this.skipDateZoom = false; });
			}
		},

	handlePlotHover(data) {
			if (!data || !data.points || data.points.length === 0) return;
			const point = data.points[0];
			const hoverTime = point.x;
			if (!hoverTime) return;
			const momentHover = moment(hoverTime);
			const hoverDateStr = momentHover.format('DD.MM.YYYY HH:00');
			
			// Ищем существующую аннотацию spikeline или добавляем новую
			const existingIdx = this.layout.annotations ? this.layout.annotations.findIndex(a => a._isSpikeLabel) : -1;
			if (existingIdx >= 0) {
				this.layout.annotations[existingIdx].text = hoverDateStr;
				this.layout.annotations[existingIdx].x = hoverTime;
			} else {
				const spikeAnnotation = {
					_isSpikeLabel: true,
					x: hoverTime,
					y: 1,
					xref: 'x',
					yref: 'paper',
					text: hoverDateStr,
					showarrow: false,
					opacity: 0.7,
					font: { size: 11, color: '#333' },
					xanchor: 'right',
					yanchor: 'bottom',
					bgcolor: 'rgba(255,255,255,0.8)',
					borderpad: 2,
					bordercolor: '#ccc',
					borderwidth: 1
				};
				this.layout.annotations = this.layout.annotations || [];
				this.layout.annotations.push(spikeAnnotation);
			}
			// Перерисовываем layout
			this.$nextTick(() => {
				if (document.getElementById('plot') && this.plotReady) {
					Plotly.react('plot', this.data, this.layout);
				}
			});
		},

		handlePlotUnhover() {
			// Удаляем аннотацию spikeline при уходе курсора
			if (this.layout.annotations) {
				this.layout.annotations = this.layout.annotations.filter(a => !a._isSpikeLabel);
				this.$nextTick(() => {
					if (document.getElementById('plot') && this.plotReady) {
						Plotly.react('plot', this.data, this.layout);
					}
				});
			}
		},

	initializePlot() {
			console.log('Setting up MutationObserver for plot element...');
			// Используем MutationObserver для отслеживания появления элемента
			this.plotMutationObserver = new MutationObserver(() => {
				const plotElement = document.getElementById('plot');
				if (plotElement) {
					console.log('Plot element appeared via MutationObserver, initializing...');
					this.plotMutationObserver.disconnect();
      // Heat stress grades by MV
          Plotly.newPlot(plotElement, this.data, {
            ...this.layout,
            title: {text: this.getVarTitle(), font: {size: 16}},
            shapes: this.get_grade_shapes(),
            annotations: this.get_grade_annotations()
          }, {responsive: true});
					// Heat stress grades by MV
					this.plotReady = true;
					console.log('DRAWING PLOT');
					
					// Подписываемся на клик по графику
					plotElement.on('plotly_click', (data) => this.handlePlotClick(data));
					
					// Подписываемся на hover по графику (кастомная подпись даты)
					plotElement.on('plotly_hover', (data) => this.handlePlotHover(data));
					plotElement.on('plotly_unhover', () => this.handlePlotUnhover());
					
					// Наблюдение за изменением размера
					this.resizeObserver = new ResizeObserver(() => {
						if (this.plotReady) {
							Plotly.Plots.resize('plot');
						}
					});
					
					this.resizeObserver.observe(plotElement);
				}
			});
			
			// Наблюдаем за изменением DOM в целом
			this.plotMutationObserver.observe(document.body, {
				childList: true,
				subtree: true
			});
		}
	},
	watch: {
				'$i18n.locale': function() {
			for (let city of Object.keys(this.stations[this.varspace])) {
				let back = this.allstations[this.varspace][city].splice(0, 1)[0];
				this.allstations[this.varspace][city].sort((a, b) => a[this.$i18n.t('fields.name')] < b[this.$i18n.t('fields.name')] ? -1 : 1 ); 
				this.allstations[this.varspace][city].unshift(back);

				let temp = this.stations[this.varspace][city];
				for (let id in this.stations[this.varspace][city]) {
					let i = this.allstations[this.varspace][city].findIndex(s => s.ID == id);
					let feature = this.allstations[this.varspace][city][i];
					temp[id] = feature[this.$i18n.t('fields.name')]
				}
				
				this.stations[this.varspace][city] = []; 
				this.stations[this.varspace][city] = temp;
			}
			this.layout.locale = this.$i18n.locale;
			this.$nextTick(() => {
				if (document.getElementById('plot') && this.plotReady) {
					Plotly.react('plot', this.data, this.layout);
				}
			});
		},
		varnames() {
			this.layout.title = {text: this.getVarTitle(), font: {size: 16}};
		},
				variable() {
					this.fetch_data();
					if (this.freescale == 'Yes')
						this.zoom_data();
				},
				city() {
					this.fetch_data();
					if (this.freescale == 'Yes')
						this.zoom_data();
				},
		appdate() {
			if (this.datebind.length > 0) {
				this.date = this.appdate;
				// Также обновляем вертикальную линию, т.к. apphour может не измениться
				// (например, клик по точке с тем же часом, но другой датой)
				const shapes = this.get_grade_shapes();
				if (this.appdate) {
					const lineDate = this.apphour != null ? this.appdate + ' ' + String(this.apphour).padStart(2, '0') + ':00:00' : this.appdate;
					shapes.push({
						type: 'line',
						x0: lineDate,
						x1: lineDate,
						y0: 0,
						y1: 1,
						xref: 'x',
						yref: 'paper',
						layer: 'above',
						line: {
							color: 'black',
							width: 1,
							dash: 'dash'
						}
					});
				}
				this.layout.shapes = shapes;
				this.layout.annotations = this.get_grade_annotations();
			}
		},
		apphour() {
			// Обновляем только пунктирную линию, не меняем границы осей
			const shapes = this.get_grade_shapes();
			if (this.appdate) {
				const lineDate = this.apphour != null ? this.appdate + ' ' + String(this.apphour).padStart(2, '0') + ':00:00' : this.appdate;
				shapes.push({
					type: 'line',
					x0: lineDate,
					x1: lineDate,
					y0: 0,
					y1: 1,
					xref: 'x',
					yref: 'paper',
					layer: 'above',
					line: {
						color: 'black',
						width: 1,
						dash: 'dash'
					}
				});
			}
			this.layout.shapes = shapes;
			this.layout.annotations = this.get_grade_annotations();
		},
		confidence() {
			this.show_cache();
		},
		standardize() {
			this.show_cache();
		},
		fetching(newval) {
			console.log('ENDED FETCHING');
			this.$emit('lock_app', newval);
		},
		datebind(newval) {
			if (newval.length > 0) {
				this.date = this.appdate;
			}
		},
		aggrbind(newval) {
			if (newval.length > 0) {
				this.aggrunit = this.aggrunit_ext;
			}
		},
				aggrunit_ext(newval) {
					if (this.aggrbind.length > 0) {
						this.aggrunit = newval;
					}
				},
				stations: {
					handler() {
						this.fetch_data();
						if (this.freescale == 'Yes')
							this.zoom_data();
					},
					deep: true
				},

		background_stations: {
			handler() {
				this.background_changed = true;
			},
			deep: true
		},

		urban_stations: {
			handler() {
				this.urbans_changed = true;
			},
			deep: true
		},
				aggrunit() {
					this.fetch_data();
					this.duration = this.durations[this.aggrunit];
					if (this.freescale == 'Yes')
						this.zoom_data();
				},
		date() {
			if (this.skipDateZoom) return;
			if (this.freescale == 'Yes')
				this.zoom_data();
		},
		data() {
			this.$nextTick(() => {
				if (document.getElementById('plot') && this.plotReady) {
					Plotly.react('plot', this.data, this.layout);
				}
			});
		},
		layout: {
			handler() {
				this.$nextTick(() => {
					if (document.getElementById('plot') && this.plotReady) {
						Plotly.react('plot', this.data, this.layout);
					}
				});
			},
			deep: true
		},
		min_date() {
			this.prefetch += 1;
		},
		max_date() {
			this.prefetch += 1;
		},
		prefetch(newval) {
			if (newval == 6) {
				this.fetch_data();
			}
		}
	},
	mounted() {
		// console.log('YEAH');
		// Загружаем все станции асинхронно, но ждем завершения

		const loadPromises = [
			this.load_allstations('moscow', 'meteo'),
			this.load_allstations('spb', 'meteo'), 
			this.load_allstations('moscow', 'air'),
			this.load_allstations('spb', 'air')
		];
		
		Promise.all(loadPromises).then(() => {
			this.edit_stations = this.stations[this.varspace];
			this.$nextTick(() => {
				console.log('All stations loaded, initializing plot...');
				this.initializePlot();
			});
		}).catch(error => {
			console.error('Error loading all stations:', error);
			this.edit_stations = this.stations[this.varspace];
			this.$nextTick(() => {
				this.initializePlot();
			});
		});
		
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
		if (this.plotMutationObserver) {
			this.plotMutationObserver.disconnect();
		}
		window.removeEventListener('resize', this.handleResize);
	},
  }
</script>

<template>
	<v-row justify="center">
		<v-expansion-panels v-model="plotindex">
			<v-expansion-panel class="plot-panel" flat>
				<v-expansion-panel-header class="text-h6 plot-header" hide-actions disable-ripple>
					<span
						class="plot-toggle-label"
						:class="{ 'toggle-expanded': plotindex === 0, 'toggle-collapsed': plotindex !== 0 }"
						@click.stop="togglePlot"
					>
						{{ $t('titles.plots') }}
					</span>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div class="fill-height d-flex">
						<div style="width:220px; min-width:220px; overflow-y:auto;">
							<v-card flat tile height="100%">
								<v-list dense style="padding-top:0px">
									<v-list-item style="padding-top:0px">
										<v-list-item-content style="padding:0px">
											<v-list-item-title class="text-h7">
												{{ $t('titles.scaling') }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>

									<v-list-item>
										<v-btn-toggle tile dense borderless v-model="freescale">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn 
														value="Yes" 
														v-bind:color="freescale == 'Yes' ? 'primary lighten-4' : ''"
														v-bind="attrs"
														v-on="on">
														<v-icon>mdi-auto-fix</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('hints.autoscale') }}</span>
											</v-tooltip>
										</v-btn-toggle>

										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													tile dense borderless depressed
													@click="zoom_data"
													v-bind="attrs"
													v-on="on">
													<v-icon>mdi-magnify-expand</v-icon>
												</v-btn>
											</template>
											<span>{{ $t('hints.reset') }}</span>
										</v-tooltip>
									</v-list-item>

									<v-list-item>
										<v-list-item-content style="padding-bottom:20px;padding-top:20px">
											<v-list-item-title class="text-h7">
												{{ $t('titles.series') }}
											</v-list-item-title>
										</v-list-item-content>

											<v-tooltip bottom>
												<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
													<v-menu offset-x max-height="500" :close-on-content-click="false" @input="handle_background" ref="backgroundMenu">
														<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
															<v-btn 
																icon
																v-bind="{ ...tooltipAttrs, ...menuAttrs }"
																v-on="{ ...tooltipOn, ...menuOn }">
																<v-icon>mdi-home-group</v-icon>
															</v-btn>
														</template>
														
														<div style="display:flex; flex-direction:column; height:100%; position:relative;">
															<v-btn
																icon
																small
																@click="closeBackgroundMenu"
																style="position:absolute; top:2px; right:2px; z-index:1;"
															>
																<v-icon small>mdi-close</v-icon>
															</v-btn>
															<div style="flex:1; overflow-y:auto; max-height:400px;">
																<v-list dense>
																	<v-list-item
																	v-for="item in allstations[varspace][city].filter(item => item.ID < 99998)"
																	:key="item.ID"
																	>
																		<v-checkbox
																			:input-value="background_stations[varspace][city].includes(item.ID)"
																			:label="item[$t('fields.name')] + ' (' + item.ID + ')'"
																			dense
																			@change="toggleBackgroundStation(item.ID)">														
																		</v-checkbox>
																	</v-list-item>
																</v-list>
															</div>
															<v-divider></v-divider>
															<div style="display:flex; gap:4px; padding:8px;">
																<v-btn
																	depressed
																	@click="toggleAllBackgroundStations"
																	small
																	style="flex:1; min-width:0;"
																>
																	All
																</v-btn>
																<v-btn
																	depressed
																	@click="defaultBackgroundStations"
																	small
																	style="flex:1; min-width:0;"
																>
																	Default
																</v-btn>
																<v-btn
																	depressed
																	color="success"
																	@click="applyBackgroundStations"
																	small
																	style="flex:1; min-width:0;"
																>
																	Apply
																</v-btn>
															</div>
														</div>
													</v-menu>
												</template>
												<span>{{ $t('hints.stations_background') }}</span>
											</v-tooltip>
										
										
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<v-btn 
													icon
													disabled
													v-on="on">
													<v-icon>mdi-city</v-icon>
												</v-btn>
											</template>
											<span>{{ $t('hints.stations_urban') }}</span>
										</v-tooltip>
										
										<!-- Add on plot -->
										<v-tooltip bottom>
											<template v-slot:activator="{ on: tooltipOn }">
												<v-menu offset-x max-height="500"> 
													<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
														<v-btn 
														icon 
														v-bind="menuAttrs"
														v-on="{ ...tooltipOn, ...menuOn }">
															<v-icon>mdi-plus</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item
														v-for="item in allstations[varspace][city]"
														:key="item.ID"
														@click="add_station(item.ID)"
														>
															<v-list-item-title>{{ item[$t('fields.name')] + ' (' + item.ID + ')' }}</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</template>
											<span>{{ $t('hints.add') }}</span>
										</v-tooltip>
										
									</v-list-item>

									<v-list-item>
										<v-container class="py-0" no-gutters>
											<v-row style="padding:0px"
												align="center"
												justify="start"
											>
												<v-col
													v-for="(selection, i) in stations[varspace][city]"
													:key="selection"
													class="shrink"
													style="padding:2px"
												>
												<!-- <v-chip
													close
													small chip
													@click:close="remove_station(i)"
												>
													{{ selection }}
												</v-chip> -->

												<v-chip small chip>
													<v-icon
														left
														small
														@click.stop="remove_station(i)"
													>
														mdi-close-circle
													</v-icon>
													{{ selection }}
												</v-chip>

												</v-col>
											</v-row>
											</v-container>
									</v-list-item>
								</v-list>
							</v-card>
						</div>
							
						<div class="plot-area" style="width:100%">
							<v-card tile flat>
								<div id="plot" style="height:300px;width:100%">
								</div>
							</v-card>
						</div>
						<v-overlay :value="fetching" :absolute=true opacity=0.3>
							<v-progress-circular
								indeterminate
								size="128"
								:opacity="opacity"
							></v-progress-circular>
						</v-overlay>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</v-row> 
</template>

<style scoped>
/* Panel wrapper — always white background */
::v-deep .plot-panel,
::v-deep .plot-panel.v-expansion-panel {
  background-color: #fff !important;
  position: relative;
  overflow: visible !important;
}

/* Header: minimal height, always white */
::v-deep .plot-panel .v-expansion-panel-header {
  padding: 2px 16px !important;
  min-height: 0 !important;
  background-color: #fff !important;
}

/* Kill the ::before pseudo-element that creates the hover/active tint */
::v-deep .plot-panel .v-expansion-panel-header::before {
  background-color: transparent !important;
}

/* Ensure header stays white in all Vuetify state classes */
::v-deep .plot-panel .v-expansion-panel-header:hover,
::v-deep .plot-panel .v-expansion-panel-header:focus,
::v-deep .plot-panel .v-expansion-panel-header.v-expansion-panel-header--active,
::v-deep .plot-panel.v-expansion-panel--active .v-expansion-panel-header {
  background-color: #fff !important;
}

/* Toggle label styling */
.plot-toggle-label {
  cursor: pointer;
}

/* Arrow indicator via ::after — shown after "Plots", stays at the right side of the text */
.plot-toggle-label.toggle-expanded::after {
  content: ' ▾';
}

.plot-toggle-label.toggle-collapsed::after {
  content: ' ▸';
}

/* Pull the plot area (right side) up to overlap the header row */
.plot-panel.v-expansion-panel--active .plot-area {
  margin-top: -36px;
}

/* Override Vuetify's content wrapper overflow:hidden so the shifted chart isn't clipped */
::v-deep .plot-panel.v-expansion-panel--active .v-expansion-panel-content__wrap {
  overflow: visible !important;
}
</style>
